// extracted by mini-css-extract-plugin
module.exports = {"container":"About_container__3mEkt","closeIcon":"About_closeIcon__vH8_H","logo":"About_logo__3FT7Z","title":"About_title__3xUCR","version":"About_version__1Gctq"};